import BigNumber from 'bignumber.js'

export function bn(n: number) {
  return BigNumber(n)
}
